export const products = [
  {
    id: 1,
    name:"Radhunir Rannaghor",
    img: "https://i.ibb.co/ccdDH2V/rannaghor.png",
    link: "https://food-catering-service-a11.web.app/home",
    technology:" React,Context Api,CSS,JavaScript,MongoDB,FireBase for authentication,Express js"
  },
  {
    id: 3,
    name:"fasionCorner",
    img: "https://i.ibb.co/5MCq7vN/Screenshot-from-2022-11-21-15-34-54.png",
    link: "https://dream-shop-fhkathika.vercel.app/",
    technology:" React,Next js,Redux,JavaScript,Styled Component,MongoDB,FireBase ,Express js "
  },
  
  {
    id: 2,
    name:"Wood Creaft",
    img: "https://i.ibb.co/kK7FGFs/wood-Craft.png",
    link: "https://wood-craft-1093b.web.app/",
    technology:" React,Context Api,JavaScript,CSS,MongoDB,FireBase for authentication,Express js"
  },
 
  
];
